module.exports = __webpack_public_path__ + "static/media/select-arrow.cc458527.svg";